import React, {FC} from "react";
import moment from "moment";
import {Alert} from "antd";
import {useGetActiveDunningQuery, useGetCompanyInfoQuery} from "../../../../generated/graphql";
import i18n from "../../../../services/i18n";
import {renderAmount} from "../../../../helpers/renderAmount";

// Getter statt Modul-Konstante (react-hot-loader, siehe BookingDunningsPanel)
const tr = () => i18n.containers.invoice.BookingDunnings;

type Props = {
    bookingId?: string;
    /** edit: Buchung bearbeiten (Betrag ändert sich), transfer: Umbuchen (Rechnung wird storniert) */
    variant: "edit" | "transfer";
};

/** Hinweis statt Einfrieren (#1517): gibt es eine aktive Mahnung, sieht man das vor dem Ändern. Blockiert nichts. */
const ActiveDunningAlert: FC<Props> = ({bookingId, variant}) => {
    const {data: company} = useGetCompanyInfoQuery({fetchPolicy: "cache-first"});
    const enabled = Boolean(company?.companyInfo?.subscription?.featureDunning);
    const {data} = useGetActiveDunningQuery({variables: {bookingId: bookingId ?? ""}, skip: !enabled || !bookingId, fetchPolicy: "network-only"});
    const dunning = data?.activeDunning;

    if (!dunning) {
        return null;
    }
    const level = tr().levels[dunning.level]();
    const message = tr().hint.edit({level, date: moment(dunning.createDate).format("DD.MM.YYYY"), amount: renderAmount({amount: dunning.totalAmount})});

    return (
        <Alert
            type={variant === "edit" ? "warning" : "info"}
            showIcon
            style={{marginBottom: 16}}
            message={message}
            description={variant === "edit" ? tr().hint.editText() : tr().hint.transferText()}
        />
    );
};

export default ActiveDunningAlert;
